import { render, staticRenderFns } from "./ArticleItemHorizontal.vue?vue&type=template&id=726ab45c&scoped=true&"
import script from "./ArticleItemHorizontal.vue?vue&type=script&lang=js&"
export * from "./ArticleItemHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItemHorizontal.vue?vue&type=style&index=0&id=726ab45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726ab45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726ab45c')) {
      api.createRecord('726ab45c', component.options)
    } else {
      api.reload('726ab45c', component.options)
    }
    module.hot.accept("./ArticleItemHorizontal.vue?vue&type=template&id=726ab45c&scoped=true&", function () {
      api.rerender('726ab45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/ArticleListBlock/ArticleItemHorizontal.vue"
export default component.exports